module.exports = __webpack_public_path__ + "static/media/chevron_right_24px.f106b4f4.svg";